import React, { useEffect } from 'react';

const RAZORPAY_BADGE_SCRIPT = 'https://cdn.razorpay.com/widgets/trusted-badge.js';

const RazorpayBadge = () => {
  useEffect(() => {
    // Load the widget only after React has added <razorpay-trusted-business>
    // to the DOM. The Razorpay script scans the page when it executes.
    if (document.querySelector('script[data-razorpay-trusted-badge]')) {
      return;
    }

    const script = document.createElement('script');
    script.src = RAZORPAY_BADGE_SCRIPT;
    script.async = true;
    script.dataset.razorpayTrustedBadge = 'true';
    script.onerror = () => {
      console.error('Unable to load the Razorpay Trusted Business widget.');
    };
    document.head.appendChild(script);
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
        className='razporpaybadgediv'
        aria-label="Razorpay Trusted Business"
        dangerouslySetInnerHTML={{
          __html: `<razorpay-trusted-business key="rzp_live_TToXw6dTcy3pq8"></razorpay-trusted-business>`,
        }}
        />
    </div>
  );
}

export default RazorpayBadge;
